import { render } from "./AdminUsersPage.vue?vue&type=template&id=4cb32d24&scoped=true"
import script from "./AdminUsersPage.vue?vue&type=script&lang=js"
export * from "./AdminUsersPage.vue?vue&type=script&lang=js"

import "./AdminUsersPage.vue?vue&type=style&index=0&id=4cb32d24&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cb32d24"]])

export default __exports__